<script lang="ts">
  import type { Props } from "./IconV1.types";
  import { useHost } from "../../../common/runtime/utils/useHost.ts";

  let { color = undefined, ocAriaLabel = undefined }: Props = $props();

  let Host = useHost();

  $effect(() => {
    if (color) {
      Host.style.setProperty("--color", color);
    } else {
      Host.style.removeProperty("--color");
    }
  });

  /*                          */
  $effect(() => {
    if (ocAriaLabel) {
      Host.setAttribute("aria-label", ocAriaLabel);
      Host.role = "img";
    } else {
      Host.removeAttribute("aria-label");
      Host.role = null;
    }
  });
</script>
